import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../shared/libs/redux';
import {
	workshopModuleTagGroupActions,
	workshopModuleTagGroupApi,
} from '../../../../../../entities/module/tag-group/workshop-module-tag-group';
import { notificationError, notificationSuccess } from '../../../../../../components/Notifications/callNotifcation';
import {
	workshopModuleTagGroupSelectors,
} from '../../../../../../entities/module/tag-group/workshop-module-tag-group/model/slice/workshopModuleTagGroupSlice';
import { workshopModuleTagApi } from '../../../../../../entities/module/workshop-module-tag';

export const useDeleteWorkshopTagGroup = () => {
	const dispatch = useAppDispatch();

	const id = useSelector(workshopModuleTagGroupSelectors.getDeletingGroupId);

	const [deleteGroup, requestData] = workshopModuleTagGroupApi.useDeleteMutation();

	const onDeleteTagGroup = async () => {
		try {
			if (id) {
				await deleteGroup({ id }).unwrap();

				dispatch(workshopModuleTagGroupActions.setIsDeleteGroupModalActive(false));

				notificationSuccess('Группа тегов удалена успешно', '', true);
				dispatch(workshopModuleTagApi.util.invalidateTags(['workshopTag']));
				dispatch(workshopModuleTagGroupApi.util.invalidateTags(['workshopTagGroup']));
			}
		} catch (e) {
			notificationError('При удалении группы тегов произошла ошибка...');
		}
	};

	return {
		onDeleteTagGroup,
		requestData,
	};
};
